// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "list-1oeq6";
var _5 = "listItem-3FXTO";
var _6 = "groups_item-3mUL-";
var _7 = "title-B3G9T";
var _8 = "header-tiofy";
var _9 = "close-1vwu_";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "list", _5 as "listItem", _6 as "groups_item", _7 as "title", _8 as "header", _9 as "close" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "list": _4, "listItem": _5, "groups_item": _6, "title": _7, "header": _8, "close": _9 }
